export default function Plus (props) {

    return (
        <svg className={props.className} style={props.style} fill={props.fill || '#000'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9">
            <path d="M 0 4 L 4 4 L 4 0 L 5 0 L 5 4 L 9 4 L 9 5 L 5 5 L 5 9 L 4 9 L 4 5 L 0 5"/>
        </svg>
    )

}